import * as React from 'react';

import * as utils from '../utils';

const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/basket`);

const $ST = DIRECTORY_THEME.SUMMARY;

export default class Summary extends React.Component {
  constructor(props) {
    super(props);

    this.renderDiscounts = this.renderDiscounts.bind(this);
  }

  renderDiscounts() {
    return this.props.discounts.map((discount, index) => {
      return (
        <div className='discount' key={index}>
          <p>{discount.description}</p>
          <p>
            {discount.discount} {utils.currencyText(this.props.currency_type)}
          </p>
        </div>
      );
    });
  }

  render() {
    const { total_amount, total_product_amount, currency_type } = this.props;

    return (
      <div className='basket-summary'>
        <div className='expense'>
          <p>{$ST.TOTAL}</p>
          <p>
            {total_product_amount}{' '}
            {currency_type ? currency_type : utils.currencyText(currency_type)}
          </p>
        </div>
        {this.renderDiscounts()}
        <div className='amount'>
          <p>{$ST.AMOUNT_TO_PAID}</p>
          <p>
            {total_amount}  {currency_type ? currency_type : utils.currencyText(currency_type)}
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/basket/Summary.js